import { initialStrollerReviewPhotoState, StrollerReviewPhotoState } from 'mk2/apps/strollers/containers/StrollerReviewPhoto/StrollerReviewPhoto.reducers';
import { AppState } from 'mk2/reducers';

export const getStrollerReviewPhotoState = (state: AppState, strollerSlug: string): StrollerReviewPhotoState =>
    state.containers.strollers.strollersReviewsPhotos[strollerSlug] || initialStrollerReviewPhotoState;
